import React from 'react';
import { ArrowRight, Play } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="min-h-screen bg-black relative overflow-hidden flex items-center">
      {/* Animated background grid */}
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      {/* Glowing orbs */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-orange-500/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <div className="space-y-8">
          {/* Main Logo/Title */}
          <div className="space-y-4 mt-24 md:mt-32">
            <h1 className="text-6xl md:text-8xl font-bold text-white futuristic-text-large">
              InSkill
            </h1>
            <div className="h-1 w-32 bg-gradient-to-r from-transparent via-orange-500 to-transparent mx-auto glow-line"></div>
          </div>

          {/* Tagline */}
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Future Skills, Inside the Classroom
          </p>

          {/* Description */}
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Choose from our intensive 🤖 14-Day AI Bootcamp or weekend AI mastermind workshop. Learn cutting-edge AI technologies, build real projects, and prepare for the future of technology.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
            <button 
              onClick={() => scrollToSection('contact')}
              className="neon-button-primary px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-300 flex items-center gap-2 group"
            >
              Join Our Programs
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </button>
            
            <button 
              onClick={() => scrollToSection('courses')}
              className="neon-button-secondary px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-300 flex items-center gap-2 group"
            >
              <Play size={20} className="group-hover:scale-110 transition-transform" />
              View Programs
            </button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-16 max-w-4xl mx-auto">
            <div className="text-center space-y-1">
              <div className="text-3xl font-bold text-orange-500 futuristic-text">2</div>
              <div className="text-gray-400">Program Options</div>
            </div>
            <div className="text-center space-y-1">
              <div className="text-3xl font-bold text-orange-500 futuristic-text">100+</div>
              <div className="text-gray-400">Students Trained</div>
            </div>
            <div className="text-center space-y-1">
              <div className="text-3xl font-bold text-orange-500 futuristic-text">24/7</div>
              <div className="text-gray-400">Mentor Support</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-orange-500 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-orange-500 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;